type SortableEntity = {
    sortOrder: number;
};

export function compareBySortOrder(a: SortableEntity, b: SortableEntity) {
    return a.sortOrder - b.sortOrder;
}
